import { ModalBody, forwardRef } from '@chakra-ui/react';
import format from 'date-fns/format';
import { ActivationPayload, AppType } from '../types';

export const ForwardedModalBody = forwardRef<any, 'div'>((props, ref) => {
  const { 'aria-label': ariaLabel } = props;
  return (
    <div
      ref={ref}
      aria-label={ariaLabel}
      style={{
        flex: '1 1 0%',
        overflow: 'auto',
        zoom: 1.3,
      }}
    >
      <ModalBody ref={ref} {...props} />
    </div>
  );
});

export const TokenCustomClaimOrgAccountIdKey =
  'https://auth.sitecorecloud.io/claims/org_account_id';
export const TokenCustomClaimOrgIdKey =
  'https://auth.sitecorecloud.io/claims/org_id';

export const constructStreamPayload = ({ region }: ActivationPayload) => ({
  agreementStartDate: format(new Date(), 'yyyy-MM-dd'),
  defaultDeploymentRegion: region === 'Europe West' ? 'Europe' : region,
  streamEdition: 'free',
  streamSkuCapacity: 'external',
});

export const constructConnectPayload = ({ region }: ActivationPayload) => ({
  sellableProductCode: 'connect',
  productCode: 'Connect_Base_Product_Stnd',
  agreementStartDate: format(new Date(), 'yyyy-MM-dd'),
  defaultDeploymentRegion: region,
  sku: 'Sitecore Connect (Standard) | Basic Trial',
});

export const regionsMap = new Map();
regionsMap.set('West Europe', 'euw');
regionsMap.set('East US', 'use');
regionsMap.set('Australia East', 'aue');
regionsMap.set('Japan East', 'jpe');
// In case of West US, we want to map with East US
regionsMap.set('West US 2', 'use');
regionsMap.set('West US', 'use');

const validRegions = [
  'West Europe',
  'East US',
  'Australia East',
  'West US 2',
  'Japan East',
  'usw',
  'jpe',
  'euw',
  'aue',
  'use',
];
export const regionValidatorPerProduct = {
  ai: (orgRegion: AppType) => validRegions.includes(orgRegion),
  Connect: () => true,
  default: () => true,
};
